import { Info } from 'react-bootstrap-icons';
import { RootState } from '../../store';
import { connect } from 'react-redux';
import { useState } from "react";
import Preferencias from '../Configuracion/Preferencias'; // Importamos Preferencias
import { ListaVersionamiento } from '../Configuracion/Versionamiento';



interface Props {
    isDarkMode: boolean;
    listaVersionamiento: ListaVersionamiento[];
    activo?: string;
}

const Footer: React.FC<Props> = ({ listaVersionamiento, isDarkMode, activo = "Versionamiento" }) => {
    const Ambiente = import.meta.env.VITE_AMBIENTE;
    const [mostrarModal, setMostrarModal] = useState(false);

    const version = listaVersionamiento[0]?.numerO_VERSION || "";

    const hoy = new Date();
    const anio = hoy.getFullYear();
    return (
        <>
            <footer className={`p-3 ${isDarkMode ? "bg-color-dark" : "bg-light"} border-top`}>
                <div className="d-flex align-items-center">
                    <p className='fs-09em'>
                        <Info width={22} height={22} aria-hidden="true" />
                        Copyright © {anio} Todos los derechos reservados SSMSO.
                        <b className='text-warning mx-1'>{Ambiente}</b>
                        <a
                            onClick={() => setMostrarModal(true)}
                            className={`fw-normal mx-1 text-decoration-none`}
                            style={{ cursor: "pointer" }}
                        >
                            <b className={`fw-semibold ${isDarkMode ? "text-white" : "text-primary"}`}>
                                v{version}
                            </b>
                        </a>
                    </p>
                </div>
            </footer>

            {/* Modal de Preferencias */}
            <Preferencias
                isDarkMode={isDarkMode}
                activo={activo}
                mostrarModal={mostrarModal}
                setMostrarModal={setMostrarModal}
            />
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    isDarkMode: state.darkModeReducer.isDarkMode,
    listaVersionamiento: state.listaVersionamientoReducers.listaVersionamiento,
});

export default connect(mapStateToProps)(Footer);